/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.3
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useContext } from "react";

// @mui core components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Settings page components
import FormField from "layouts/pages/account/components/FormField";

// Auth context
import { AuthContext } from "utils/jwtContext";

function BasicInfo() {
  // Get user data from AuthContext
  const { user } = useContext(AuthContext);
  
  // Extract user fields with fallbacks
  const firstName = user?.first_name || "-";
  const lastName = user?.last_name || "-";
  const email = user?.email || "";
  const institution = user?.institution || "";

  return (
    <Card id="profile" sx={{ overflow: "visible" }}>
      <SoftBox p={3}>
        <SoftTypography variant="h5">Informații Profil</SoftTypography>
        <SoftTypography variant="body2" color="text">
          Informațiile dumneavoastră personale
        </SoftTypography>
      </SoftBox>
      <SoftBox 
        component="form" 
        pb={3} 
        px={3}
        sx={{
          "& label": {
            color: "#9e9e9e !important",
          },
          "& .MuiInputBase-root": {
            backgroundColor: "#f5f5f5 !important",
            cursor: "not-allowed !important",
          },
          "& .MuiInputBase-input": {
            WebkitTextFillColor: "#757575 !important",
            color: "#757575 !important",
            cursor: "not-allowed !important",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#d0d0d0 !important",
          },
          "& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#d0d0d0 !important",
          }
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <FormField 
              label="Nume" 
              placeholder="Nume" 
              value={firstName}
              inputProps={{ readOnly: true, disabled: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField 
              label="Prenume" 
              placeholder="Prenume" 
              value={lastName}
              inputProps={{ readOnly: true, disabled: true }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormField
              label="Email"
              placeholder="example@email.com"
              value={email}
              inputProps={{ type: "email", readOnly: true, disabled: true }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormField
              label="Instituție"
              placeholder="Instituție"
              value={institution}
              inputProps={{ readOnly: true, disabled: true }}
            />
          </Grid>
        </Grid>
      </SoftBox>
    </Card>
  );
}

export default BasicInfo;
